import { PitchEvents } from '@/types/visualisation';
import { getVideoIdsFromEventMarkers } from '@/utils/video';
import { Atom, useAtomValue } from 'jotai';

export const useVideoDataFromEventMarkers = (eventMarkersAtom: Atom<Promise<PitchEvents>>) => {
  const eventsForMetric = useAtomValue(eventMarkersAtom);
  const allEvents = [...eventsForMetric.arrowEvents, ...eventsForMetric.markerEvents];
  const videoAccessibleEvents = allEvents.filter(e => e.hasVideo);
  const videoIds = getVideoIdsFromEventMarkers(videoAccessibleEvents);
  const unavailableVideosCount = allEvents.length - videoIds.length;

  return { videoIds, unavailableVideosCount };
};
